const actions = {
  LOAD_SUBSCRIPTION_LIST: 'LOAD_SUBSCRIPTION_LIST',
  LOAD_SUBSCRIPTION_LIST_SUCCESS: 'LOAD_SUBSCRIPTION_LIST_SUCCESS',
  SAVE_SUBSCRIPTION_LIST: 'SAVE_SUBSCRIPTION_LIST',

  LOAD_EXERCISE_LIST: 'LOAD_EXERCISE_LIST',
  LOAD_EXERCISE_LIST_SUCCESS: 'LOAD_EXERCISE_LIST_SUCCESS',
  SAVE_EXERCISE_LIST: 'SAVE_EXERCISE_LIST',

  LOAD_API_ERROR: 'LOAD_API_ERROR',
  SAVE_API_ERROR: 'SAVE_API_ERROR',

  TOGGLE_LOADING: 'TOGGLE_LOADING',

  toggleLoading: (value) => ({ type: actions.TOGGLE_LOADING, payload: { value } }),

  loadSubscriptionApi: (pagination, data) => {
    return { type: actions.LOAD_SUBSCRIPTION_LIST, pagination, data };
  },
  loadSubscriptionApiSuccess: (pagination, data) => ({
    type: actions.LOAD_SUBSCRIPTION_LIST_SUCCESS,
    payload: { pagination, data }
  }),
  loadExerciseApi: (data) => {
    return { type: actions.LOAD_EXERCISE_LIST, data };
  },
  loadExerciseApiSuccess: (data) => ({
    type: actions.LOAD_EXERCISE_LIST_SUCCESS,
    payload: { data }
  }),
  loadApiError: (error) => ({
    type: actions.LOAD_API_ERROR,
    payload: { error }
  }),
  saveApiError: (error) => ({
    type: actions.SAVE_API_ERROR,
    payload: { error }
  })
};

export default actions;
